export default {
    IONIQ_BEV: {
        CAPACITY: 28,
        SLOW_SPEED: 2.3,
        NORMAL_SPEED: 4.6,
        FAST_SPEED: 50
    },
    AMPERA_E: {
        CAPACITY: 60,
        SLOW_SPEED: 2.3,
        NORMAL_SPEED: 4.6,
        FAST_SPEED: 40
    },
    BOLT_EV: {
        CAPACITY: 60,
        SLOW_SPEED: 2.3,
        NORMAL_SPEED: 4.6,
        FAST_SPEED: 40
    },
    NIRO_EV: {
        CAPACITY: 64,
        SLOW_SPEED: 2.3,
        NORMAL_SPEED: 4.6,
        FAST_SPEED: 50
    },
    IONIQ_HEV: {
        CAPACITY: 1.6,
        SLOW_SPEED: 0,
        NORMAL_SPEED: 0,
        FAST_SPEED: 0
    },
    IONIQ_PHEV: {
        CAPACITY: 8.9,
        SLOW_SPEED: 2.3,
        NORMAL_SPEED: 4.6,
        FAST_SPEED: 0
    },
    KONA_EV: {
        CAPACITY: 64,
        SLOW_SPEED: 2.3,
        NORMAL_SPEED: 4.6,
        FAST_SPEED: 50
    },
    SOUL_EV: {
        CAPACITY: 28,
        SLOW_SPEED: 2.3,
        NORMAL_SPEED: 4.6,
        FAST_SPEED: 50
    },
    ZOE_Q210: {
        CAPACITY: 22,
        SLOW_SPEED: 2.3,
        NORMAL_SPEED: 22,
        FAST_SPEED: 43
    }
}